import { useAccountsStore } from "@/lib/accounts/store";

/**
 * Identity of the account that owns a desk. Mirrors the account scoping the OHLC
 * cache already uses (`generateAccountSymbolKey`), plus the login so two accounts
 * on the same broker/server keep separate desks.
 *
 * Kept out of `storage.ts` so the accounts store can import `clearDesk()`
 * without creating an import cycle.
 */
export function currentDeskAccountKey(): string | null {
  try {
    const { activeAccountId, accounts } = useAccountsStore.getState();
    if (!activeAccountId) return null;
    const account = accounts.find((acc) => acc.id === activeAccountId);
    if (!account) return null;
    const login = account.credentials?.login ?? "";
    if (!account.companyName || !account.serverName || !login) return null;
    return `${account.companyName}_${account.serverName}_${login}`;
  } catch {
    return null;
  }
}
